import {DatePipe, DecimalPipe, registerLocaleData} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';

import localeCs from '@angular/common/locales/cs';
import localeEn from '@angular/common/locales/en';
import {Injectable, NgModule} from '@angular/core';
import {MatStepperIntl} from '@angular/material/stepper';
import {MatTabsModule} from '@angular/material/tabs';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import '@extensions/@all.extension';
import {FuseProgressBarModule, FuseSidebarModule} from '@fuse/components';

import {FuseModule} from '@fuse/fuse.module';
import {FuseSharedModule} from '@fuse/shared.module';
import {ErrorInterceptorProvider} from '@interceptors/error.interceptor';
import {LanguageInterceptorProvider} from '@interceptors/language.interceptor';
import {TranslateModule} from '@ngx-translate/core';
import {GoogleChartComponent, GoogleChartsModule, ScriptLoaderService} from 'angular-google-charts';
import {SimpleNotificationsModule} from 'angular2-notifications';
import {AppRoutingModule} from 'app/app-routing.module';

import {AppComponent} from 'app/app.component';
import {CoreModule} from 'app/core/core.module';
import {UserInfoModule} from 'app/core/userInfo.module';

import {fuseConfig} from 'app/fuse-config';
import {LayoutModule} from 'app/layout/layout.module';
import {environment} from 'environments/environment';
import 'hammerjs';

registerLocaleData(localeCs);
registerLocaleData(localeEn);

export function isDebugAutofill(): boolean {
    return !environment.production && environment.auto_fill;
}

export function isDebug(): boolean {
    return !environment.production;
}

@Injectable({providedIn: 'root'})
export class MyMatStepperIntl extends MatStepperIntl {
    optionalLabel = '';
}

@NgModule({
    declarations: [
        AppComponent,
    ],
    providers: [
        DatePipe,
        DecimalPipe,
        GoogleChartComponent,
        ScriptLoaderService,
        {provide: MatStepperIntl, useClass: MyMatStepperIntl},
        ErrorInterceptorProvider,
        LanguageInterceptorProvider,
    ],
    imports: [
        BrowserModule,
        CoreModule.forRoot(),
        UserInfoModule,
        BrowserAnimationsModule,
        HttpClientModule,
        AppRoutingModule,
        TranslateModule.forRoot(),
        SimpleNotificationsModule.forRoot({
            timeOut: 7000
        }),

        // Fuse modules
        FuseModule.forRoot(fuseConfig),
        FuseProgressBarModule,
        FuseSharedModule,
        FuseSidebarModule,

        // Material
        MatTabsModule,

        // App modules
        LayoutModule,
        UserInfoModule,
        GoogleChartsModule.forRoot({version: '49', safeMode: true}),
    ],
    exports: [],
    entryComponents: [],
    bootstrap: [
        AppComponent,
    ],
})
export class AppModule {
}
